var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIntegrations1 = function SvgIntegrations1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    fill: "none",
    viewBox: "0 0 25 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6CFF",
    fillRule: "evenodd",
    d: "M8.427 2.249a.85.85 0 0 1 1.201 0l3.215 3.215.5-.5 1.2-1.2.01.008.876-.876a.85.85 0 0 1 1.2 1.2l-.876.877 3.708 3.708a3.396 3.396 0 0 1 0 4.803l-1.802 1.802 3.137 3.137a.85.85 0 1 1-1.2 1.2l-3.138-3.136-1.343 1.343a3.396 3.396 0 0 1-4.803 0l-3.708-3.708-.764.764a.85.85 0 1 1-1.2-1.201l.763-.764-.008-.009 1.07-1.07-3.216-3.216a.85.85 0 0 1 1.2-1.2l3.217 3.215 3.976-3.977L8.427 3.45a.85.85 0 0 1 0-1.2M7.805 12.92l3.708 3.708a1.7 1.7 0 0 0 2.402 0l4.345-4.346a1.7 1.7 0 0 0 0-2.401l-3.708-3.708z",
    clipRule: "evenodd"
  })));
};
export default SvgIntegrations1;